(function () {
  /* Fade-in on scroll */
  function revealAll(root) {
    var items = (root || document).querySelectorAll('.dv-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Finish swatches: swap photo + links on hover (desktop) or tap (touch) */
  function selectSwatch(btn) {
    var card = btn.closest('[data-dv-card]');
    if (!card || btn.classList.contains('is-active')) return;
    var main = card.querySelector('img.is-main');
    if (main) {
      card.classList.add('is-swapping');
      var img = new Image();
      img.onload = function () {
        main.srcset = btn.getAttribute('data-srcset');
        main.src = btn.getAttribute('data-src');
        requestAnimationFrame(function () { card.classList.remove('is-swapping'); });
      };
      img.src = btn.getAttribute('data-src');
    }
    card.querySelectorAll('[data-dv-swatch]').forEach(function (s) {
      s.classList.remove('is-active');
      s.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');
    var url = btn.getAttribute('data-url');
    card.querySelectorAll('[data-dv-link]').forEach(function (a) { a.setAttribute('href', url); });
    var label = card.querySelector('[data-dv-finish]');
    if (label) label.textContent = btn.getAttribute('data-name');
  }

  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dv-swatch]');
    if (btn) { e.preventDefault(); selectSwatch(btn); }
  });
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var btn = e.target.closest && e.target.closest('[data-dv-swatch]');
      if (btn) selectSwatch(btn);
    });
  }

  /* Footer columns collapse on small screens */
  function footerAccordions() {
    if (window.innerWidth < 600) {
      document.querySelectorAll('.dv-footer__acc[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  }

  document.addEventListener('DOMContentLoaded', function () { revealAll(document); footerAccordions(); });
  document.addEventListener('shopify:section:load', function (e) { revealAll(e.target); });
})();
